import React, { useMemo } from "react";
import PropTypes from "prop-types";
import { Redirect, Switch, useRouteMatch } from "react-router-dom";
import { ModuleContext } from "../../../contexts";
import Page from "../Page";

const Module = ({ children, moduleName, description: moduleDescription }) => {
  const match = useRouteMatch();

  const otherRoutes = useMemo(
    () =>
      React.Children.map(children, (route) => {
        const { path } = route.props;
        const relativePath = `${match.url}${path}`;
        return React.cloneElement(route, {
          ...route.props,
          path: relativePath,
          exact: true,
        });
      }),
    [children, match.url]
  );

  const pages = useMemo(
    () =>
      otherRoutes
        .filter(({ props: { path } }) => path !== `${match.url}/`)
        .map(
          ({
            props: {
              path,
              title: pageTitle,
              description,
              disableNavigation,
              parentPage,
            },
          }) => ({
            path,
            pageTitle,
            description,
            disableNavigation,
            parentPage,
          })
        ),
    [match.url, otherRoutes]
  );

  const moduleUrl = useMemo(() => match.url, [match.url]);

  const context = useMemo(
    () => ({
      moduleUrl,
      moduleName,
      pages,
      moduleDescription,
    }),
    [moduleDescription, moduleName, moduleUrl, pages]
  );

  return (
    <ModuleContext.Provider value={{ ...context }}>
      <Switch>
        {otherRoutes}
        <Redirect to={moduleUrl} />
      </Switch>
    </ModuleContext.Provider>
  );
};

Module.defaultProps = {
  description: null,
};

Module.propTypes = {
  moduleName: PropTypes.string.isRequired,
  description: PropTypes.string,
};

Module.Page = Page;

export default Module;
